import React from 'react';
import { UserIcon, BellIcon, ShieldIcon, GlobeIcon, CreditCardIcon, KeyIcon } from 'lucide-react';
export function Settings() {
  return <div className="max-w-4xl mx-auto space-y-6" data-id="element-627">
      <div data-id="element-628">
        <h1 className="text-2xl font-bold text-gray-800" data-id="element-629">Einstellungen</h1>
        <p className="text-sm text-gray-500 mt-1" data-id="element-630">
          Verwalten Sie Ihre Konto- und Anwendungseinstellungen
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-631">
        <div className="space-y-6" data-id="element-632">
          <div className="bg-white rounded-lg shadow p-6" data-id="element-633">
            <div className="flex items-center space-x-3 mb-6" data-id="element-634">
              <div className="w-20 h-20 bg-gray-100 rounded-full flex items-center justify-center" data-id="element-635">
                <UserIcon size={32} className="text-gray-400" data-id="element-636" />
              </div>
              <div data-id="element-637">
                <h3 className="font-medium" data-id="element-638">Max Mustermann</h3>
                <p className="text-sm text-gray-500" data-id="element-639">Administrator</p>
              </div>
            </div>
            <button className="w-full px-4 py-2 text-sm font-medium text-white bg-[#17B978] rounded-lg hover:bg-[#148F5F]" data-id="element-640">
              Profilbild ändern
            </button>
          </div>
          <nav className="bg-white rounded-lg shadow divide-y divide-gray-100" data-id="element-641">
            {[{
            icon: UserIcon,
            label: 'Profil',
            active: true
          }, {
            icon: BellIcon,
            label: 'Benachrichtigungen'
          }, {
            icon: ShieldIcon,
            label: 'Sicherheit'
          }, {
            icon: GlobeIcon,
            label: 'Sprache & Region'
          }, {
            icon: CreditCardIcon,
            label: 'Abrechnung'
          }].map((item, index) => <button key={index} className={`w-full flex items-center space-x-3 px-4 py-3 text-sm ${item.active ? 'text-[#17B978] bg-green-50' : 'text-gray-700 hover:bg-gray-50'}`} data-id="element-642">
                <item.icon size={18} data-id="element-643" />
                <span data-id="element-644">{item.label}</span>
              </button>)}
          </nav>
        </div>
        <div className="md:col-span-2 space-y-6" data-id="element-645">
          <div className="bg-white rounded-lg shadow" data-id="element-646">
            <div className="p-6 border-b border-gray-100" data-id="element-647">
              <h2 className="text-lg font-medium" data-id="element-648">Profildetails</h2>
              <p className="text-sm text-gray-500 mt-1" data-id="element-649">
                Aktualisieren Sie Ihre persönlichen Informationen
              </p>
            </div>
            <div className="p-6 space-y-4" data-id="element-650">
              <div className="grid grid-cols-2 gap-4" data-id="element-651">
                <div data-id="element-652">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-653">
                    Vorname
                  </label>
                  <input type="text" className="w-full px-3 py-2 border border-gray-300 rounded-md" defaultValue="Max" data-id="element-654" />
                </div>
                <div data-id="element-655">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-656">
                    Nachname
                  </label>
                  <input type="text" className="w-full px-3 py-2 border border-gray-300 rounded-md" defaultValue="Mustermann" data-id="element-657" />
                </div>
              </div>
              <div data-id="element-658">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-659">
                  E-Mail-Adresse
                </label>
                <input type="email" className="w-full px-3 py-2 border border-gray-300 rounded-md" defaultValue="max.mustermann@example.com" data-id="element-660" />
              </div>
              <div data-id="element-661">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-662">
                  Unternehmen
                </label>
                <input type="text" className="w-full px-3 py-2 border border-gray-300 rounded-md" defaultValue="Musterfirma GmbH" data-id="element-663" />
              </div>
            </div>
            <div className="p-6 bg-gray-50 flex justify-end" data-id="element-664">
              <button className="px-4 py-2 text-sm font-medium text-white bg-[#17B978] rounded-lg hover:bg-[#148F5F]" data-id="element-665">
                Änderungen speichern
              </button>
            </div>
          </div>
          <div className="bg-white rounded-lg shadow" data-id="element-666">
            <div className="p-6 border-b border-gray-100" data-id="element-667">
              <h2 className="text-lg font-medium" data-id="element-668">Sicherheit</h2>
              <p className="text-sm text-gray-500 mt-1" data-id="element-669">
                Verwalten Sie Ihre Sicherheitseinstellungen
              </p>
            </div>
            <div className="p-6 space-y-6" data-id="element-670">
              <div className="flex items-center justify-between" data-id="element-671">
                <div className="flex items-center space-x-3" data-id="element-672">
                  <div className="p-2 bg-blue-100 rounded-lg" data-id="element-673">
                    <KeyIcon size={18} className="text-blue-600" data-id="element-674" />
                  </div>
                  <div data-id="element-675">
                    <h3 className="text-sm font-medium" data-id="element-676">Passwort ändern</h3>
                    <p className="text-sm text-gray-500" data-id="element-677">
                      Zuletzt geändert vor 3 Monaten
                    </p>
                  </div>
                </div>
                <button className="text-sm font-medium text-[#17B978] hover:text-[#148F5F]" data-id="element-678">
                  Aktualisieren
                </button>
              </div>
              <div className="flex items-center justify-between" data-id="element-679">
                <div className="flex items-center space-x-3" data-id="element-680">
                  <div className="p-2 bg-purple-100 rounded-lg" data-id="element-681">
                    <ShieldIcon size={18} className="text-purple-600" data-id="element-682" />
                  </div>
                  <div data-id="element-683">
                    <h3 className="text-sm font-medium" data-id="element-684">
                      Zwei-Faktor-Authentifizierung
                    </h3>
                    <p className="text-sm text-gray-500" data-id="element-685">Nicht aktiviert</p>
                  </div>
                </div>
                <button className="text-sm font-medium text-[#17B978] hover:text-[#148F5F]" data-id="element-686">
                  Aktivieren
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}